import { useEffect, useState } from 'react'
import { readImageFile } from '../helpers'

const useReadImage = (file: File | null): string | null => {
  const [imageDataUrl, setImageDataUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!file) return setImageDataUrl(null)
    ;(async () => {
      const result = await readImageFile(file)
      if (result?.imageDataUrl) {
        setImageDataUrl(result.imageDataUrl)
      }
    })()
  }, [file])

  return imageDataUrl
}

export default useReadImage
